/* fadeinEffect
========================================================= */
export function fadeinEffect($) {
  $(window).scroll(function () {
    $('.effect-fade').each(function () {
      const elemPos = $(this).offset().top;
      const scroll = $(window).scrollTop();
      const windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-scroll');
      }
    });
  });
}
